//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { uid } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import FroalaNotifications from "@/components/DocumentEditor/Froala/FroalaNotifications.vue";
import { formatDataModelVar } from "@/components/DocumentEditor/Froala/DatamodelTable";

export default {
    components: {
        FroalaNotifications,
        AQButton,
        AQBadge,
        AQInput,
        AQDropdown,
        variablesCard: () => import(/* webpackChunkName: "variablesCard" */ "@/components/Diagrams/variables-card.vue")
    },

    props: {
        uuid: {
            required: true,
            type: String
        },
        elementIndex: {
            type: Number
        },
        readonly: {
            type: Boolean
        },
        dataContent: Object,
        selectedTab: String,
        emailOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            taskSubject: null,
            showVariables: false,
            attachment: [],
            emailSubject1: null,
            body1: "",
            data: null,
            newAttachments: [],
            attachmentsData: [],
            listAttachment: [],
            typeVariablesClicked: "",
            optionsAttachments: [],
            url: "",
            uploadedFiles: [],
            activeTab: "",
            msgSubjectType: this.$t("dataTable.btnData"),
            msgBodyType: this.$t("dataTable.btnData"),
            selected: {
                name: "",
                id: uid(),
                processDefinitionId: "",
                template: "",
                rules: [],
                repeatableParameters: [],
                blockCounter: 0,
                repeatableBlockCounter: 0
            },
            attachmentOptions: [],
            attachmentModDefault: []
        };
    },
    computed: {
        ...mapGetters("diagrams", [
            "selectedPluginConfigData",
            "modelForProcessDefinition",
            "getExternalDraftDataEmail",
            "getExternalDraftDataEmailAuth"
        ]),
        ...mapActions("diagrams", ["getModelForProcessDefinition"]),

        emailSubject: {
            get() {
                return this.emailSubject1;
            },
            set(v) {
                this.emailSubject1 = v;
                if (this.selectedTab === "sms") {
                    this.$store.commit("diagrams/setExternalDraftDataEmailAuth", {
                        ...this.getExternalDraftDataEmailAuth,
                        subject: this.emailSubject1
                    });
                } else {
                    this.$store.commit("diagrams/setExternalDraftDataEmail", {
                        ...this.getExternalDraftDataEmail,
                        subject: this.emailSubject1
                    });
                }
            }
        },

        body: {
            get() {
                return this.body1;
            },
            set(v) {
                this.body1 = v;
            }
        },

        modelAttachs() {
            return this.modelForProcessDefinition({
                showOnlyType: { Attachment: true }
            });
        },
        getAttachmentProps() {
            return {
                label: this.$t("diagrams.components.taskEmail.dataAttachments"),
                options: this.attachmentOptions,
                disable: !this.attachmentOptions.length,
                hasCheckbox: true,
                isMultiselect: true,
                clearableChip: true,
                addSearch: true
            };
        }
    },
    watch: {
        dataContent: {
            handler(newValue) {
                if (newValue) {
                    this.emailSubject1 = newValue.subject ? newValue.subject : null;
                    this.listAttachment = newValue.attachments ? newValue.attachments : [];
                    this.$nextTick(() => {
                        this.selected.template = newValue.bodyEmail || newValue.body;
                        this.selected.rules = newValue.rules;
                        this.selected.repeatableParameters = newValue.repeatableParameters;
                        this.body1 = this.selected.template || "";
                    });
                }
            },
            immediate: true
        }
    },

    created() {
        this.$store.dispatch("diagrams/getModelForProcessDefinition").then(data => {
            this.newAttachments = data.data.modelClasses;
            let primaryAttachments = [];
            primaryAttachments = this.parseData(this.modelAttachs);
            this.attachmentOptions = primaryAttachments.map(elem => ({ value: elem.value, label: elem.label }));
            if (this.listAttachment.length) {
                this.attachmentModDefault = typeof this.listAttachment[0] === "object" ? this.listAttachment.map(elem => elem.value) : this.listAttachment;
            }
        });
        this.$nextTick(() => {
            const contenteditable = this.$refs && this.$refs.email_editor ? this.$refs.email_editor.$el.querySelector("[contenteditable]") : null;
            if (contenteditable) {
                contenteditable.addEventListener("focus", () => {
                    this.changeOnFocus("body");
                });
            }
        });
    },
    methods: {
        attachmentChanges(data) {
            if (this.attachmentOptions.length) {
                if (this.selectedTab === "sms") {
                    this.$store.commit("diagrams/setExternalDraftDataEmailAuth", {
                        ...this.getExternalDraftDataEmailAuth,
                        attachments: data || []
                    });
                } else {
                    this.$store.commit("diagrams/setExternalDraftDataEmail", {
                        ...this.getExternalDraftDataEmail,
                        attachments: data || []
                    });
                }
            }
        },
        onFieldClicked(data) {
            if (this.typeVariablesClicked !== "subject") {
                let newElemment = "";
                newElemment = formatDataModelVar({ formatted: data.field.variable, model: data.field.name, type: data.field.type });
                this.$root.$emit("sendElToInsert", newElemment);
            } else {
                document.execCommand("insertHTML", false, `<span class="variable">${data.field.variable}</span>`);
            }
        },
        addNewAttachment() {
            this.$refs.uploadAttachments.pick();
        },
        activateVariables(type, selectedOption) {
            if (type === "subject") {
                this.showVariables = this.typeVariablesClicked === type ? !this.showVariables : true;
                this.msgSubjectType = selectedOption || this.msgSubjectType;
                this.activeTab = this.msgSubjectType === "VAR" ? "variables" : "dataModel";
            } else {
                this.showVariables = this.typeVariablesClicked === type ? !this.showVariables : true;
                this.msgBodyType = selectedOption || this.msgBodyType;
                this.activeTab = this.msgBodyType === "VAR" ? "variables" : "dataModel";
            }
            this.typeVariablesClicked = type;
            this.$root.$emit("resetPicker");
            // this.showVariables = selectedOption ? this.showVariables : true;
        },
        parseData(data) {
            const options = [];
            if (data) {
                data.forEach(el => {
                    if (el.fields && el.fields.length) {
                        el.fields.forEach(field => {
                            options.push({
                                label: field.name,
                                value: field.name,
                                sublabel: el.name,
                                inset: true
                            });
                        });
                    }
                });
            }

            return options;
        },
        changeOnFocus(custom) {
            this.typeVariablesClicked = custom;
        }
    },

    selected(item) {
        this.$toast.showNotify({
            type: "error",
            message: `Selected suggestion "${item}"`
        });
    }

};
